import { call, put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as PaymentActions from "../actions/AddPaymentAccount";
import * as PublishingActions from "../actions/AddPublishingAccount";
import * as Actions from "../actions/FetchPaymentAccountSummary";

export function* addAccountToOrganization(
    action:
        | PaymentActions.AddPaymentAccountToOrganizationAction
        | PublishingActions.AddPublishingAccountToOrganizationAction
) {
    const { payload } = action;
    const { credentials, organizationId } = payload;
    const api = new ApiGatewayApi({
        xappUserToken: credentials.accessToken
    });

    try {
        yield put(loading(true, action));
        if (action.type === PaymentActions.ADD_PAYMENT_ACCOUNT) {
            // @ts-ignore yields generate implicit anys as of TS 4.2
            const org = yield call(api.addPaymentAccountToOrganization, organizationId, action.payload.account);
            yield put(PaymentActions.addPaymentAccountToOrganizationEnd(undefined, org));
            yield put(
                Actions.fetchPaymentAccountSummaryWithCredentials(
                    action.payload.organizationId,
                    action.payload.credentials
                )
            );
        } else {
            // @ts-ignore yields generate implicit anys as of TS 4.2
            const org = yield call(api.addPublishingAccountToOrganization, organizationId, action.payload.account);
            yield put(PublishingActions.addPublishingAccountToOrganizationEnd(undefined, org));
        }
        yield put(addNotification("Account successfully added to organization"));
    } catch (e) {
        if (action.type === PaymentActions.ADD_PAYMENT_ACCOUNT) {
            yield put(PaymentActions.addPaymentAccountToOrganizationEnd(e));
        } else {
            yield put(PublishingActions.addPublishingAccountToOrganizationEnd(e));
        }
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchAddPaymentAccount() {
    yield takeEvery(PaymentActions.ADD_PAYMENT_ACCOUNT, addAccountToOrganization);
}

export function* watchAddPublishingAccount() {
    yield takeEvery(PublishingActions.ADD_PUBLISHING_ACCOUNT, addAccountToOrganization);
}
